import {
    CaseDataExporterService, CaseReevaluationService, ConsoleLogger,
    ContainerTypes, DataSynchListService, DataSynchService, NamedBindings,
} from "@dandelion/core";
import {
    ActivationPeriodsForCrfStorage,
    CrfServiceFromFolder,
    InMemoryAccessRightsStorage,
    LocalDataSynchStorage,
    LocalKeyStorage,
    LocalSynchEventsStorage,
    RESTKeyStorage,
    ExportConfigurationsStorage,
} from "@dandelion/core/storages";
import { NamedServices } from "../enum/NamedServices";
import { ImporterService } from "./ImporterService";
import { EventSynchStorage } from "../repository/EventSynchStorage";
import { DataSynchStorage } from "../repository/DataSynchStorage";
import { InMemoryCacheStorageByYear } from "../repository/InMemoryCacheStorageByYear";
import { ReadmissionService } from "./ReadmissionService";
import { UserService } from "./UserService";
import { PdfService } from "./PdfService";
import { YearService } from "./YearService";
import { RESTStorageForEvents } from "../repository/RESTStorageForEvents";
import { interfaces } from "inversify";
import { LocalReadmissionStorage } from "../repository/LocalReadmissionStorage";
import { NamedStorages } from "../enum/NamedStorages";
import { RestReadmissionStorage } from "../repository/RestReadmissionStorage";
import { CRFVersionSelectionStrategyForProsafe } from "./CRFVersionSelectionStrategyForProsafe";
import { LocalCaseStorageForProsafe } from "../repository/LocalCaseStorageForProsafe";
import { RESTCaseStorageForProsafe } from "../repository/RESTCaseStorageForProsafe";
import { defaultAccessRights } from "../entities/AccessRights";
import { RESTAccessRightsStorageforProsafe } from "../repository/RESTAccessRightsStorageForProsafe";
import { LocalStorageForEventsForProsafe } from "../repository/LocalStorageForEventsForProsafe";
import { ProsafeExportButtonConfigs } from "../utils/ProsafeExportButtonConfigs";
import { ExportConfigurationsStorageForProsafe } from "../repository/ExportConfigurationsStorageForProsafe";

const useLocalStorage = import.meta.env.VITE_APP_LOCAL_STORAGE && import.meta.env.VITE_APP_LOCAL_STORAGE == 'true';

export const sharedServicesList = [
    { name: NamedBindings.VariablesCacheStorage, class: InMemoryCacheStorageByYear },
    { name: NamedBindings.Logger, class: ConsoleLogger },
    { name: NamedBindings.UserService, class: UserService },
    {
      name: NamedBindings.ExportConfigurationsStorage,
      instance: () => new ExportConfigurationsStorage(ProsafeExportButtonConfigs),
    },
    {
        name: NamedBindings.CRFService, instance: (context: interfaces.Context) =>
            new CrfServiceFromFolder(context.container.get(NamedBindings.Logger), context.container.get(NamedBindings.CoreConfiguration), context.container.get(NamedBindings.TranslationService), '/crfs')
    },
    { name: NamedServices.ReadmissionService, class: ReadmissionService },
    { name: NamedServices.YearService, class: YearService },
    {
        name: NamedBindings.AccessRightsStorage, instance: (context: interfaces.Context) => useLocalStorage ? new InMemoryAccessRightsStorage(defaultAccessRights) :
            new RESTAccessRightsStorageforProsafe(context.container.get(NamedBindings.HeaderProvider), context.container.get(NamedBindings.CoreConfiguration))
    }
]

export const servicesList = [
    {
        name: NamedServices.ImporterService, class: ImporterService,
        containerTypes: [ContainerTypes.DEFAULT]
    },
    {
        name: NamedServices.PdfService, class: PdfService,
        containerTypes: [ContainerTypes.DEFAULT]
    },
    {
        name: NamedBindings.DataSynchService, class: DataSynchService,
        containerTypes: [ContainerTypes.DEFAULT]
    },
    {
        name: NamedBindings.DataSynchListService, class: DataSynchListService,
        containerTypes: [ContainerTypes.DEFAULT]
    },
    {
        name: NamedBindings.CRFVersionSelectionStrategy, class: CRFVersionSelectionStrategyForProsafe,
        containerTypes: [ContainerTypes.DEFAULT, ContainerTypes.REEVALUATION]
    },
    {
        name: NamedBindings.StorageForEvents, class: useLocalStorage ? LocalStorageForEventsForProsafe : RESTStorageForEvents,
        containerTypes: [ContainerTypes.DEFAULT, ContainerTypes.REEVALUATION]
    },
    {
        name: NamedBindings.KeyStorage, class: useLocalStorage ? LocalKeyStorage : RESTKeyStorage,
        containerTypes: [ContainerTypes.DEFAULT, ContainerTypes.REEVALUATION]
    },
    {
        name: NamedBindings.CaseStorage, class: useLocalStorage ? LocalCaseStorageForProsafe : RESTCaseStorageForProsafe,
        containerTypes: [ContainerTypes.DEFAULT, ContainerTypes.REEVALUATION]
    },
    {
        name: NamedBindings.CaseReevaluationService, class: CaseReevaluationService,
        containerTypes: [ContainerTypes.DEFAULT]
    },
    {
        name: NamedBindings.CaseDataExporterService, class: CaseDataExporterService,
        containerTypes: [ContainerTypes.DEFAULT]
    },
    {
        name: NamedBindings.ActivationPeriodForCentreCodeStorage, class: ActivationPeriodsForCrfStorage,
        containerTypes: [ContainerTypes.DEFAULT, ContainerTypes.REEVALUATION]
    },
    {
        name: NamedBindings.DataSynchStorage, class: useLocalStorage ? LocalDataSynchStorage : DataSynchStorage,
        containerTypes: [ContainerTypes.DEFAULT, ContainerTypes.REEVALUATION]
    },
    {
        name: NamedBindings.StorageForSynchEvents, class: useLocalStorage ? LocalSynchEventsStorage : EventSynchStorage,
        containerTypes: [ContainerTypes.DEFAULT, ContainerTypes.REEVALUATION]
    },
    {
        name: NamedStorages.ReadmissionStorage, class: useLocalStorage ? LocalReadmissionStorage : RestReadmissionStorage,
        containerTypes: [ContainerTypes.DEFAULT]
    }
]